









































// Libraries
import { Component, Prop } from 'vue-property-decorator'
import { mapState } from 'vuex'

import { db } from '@/database'

import { currentPeriodNumber, timeNumericValue } from 'match-central-shared/dist/game-clock'

// Mixins
import MatchMixin from '@/mixins/match'

// Sub views
import PenaltyDuration from './PenaltyDuration.vue'
import { Penalty } from 'match-central-shared/src/types/penalties'

@Component({
  components: {
    PenaltyDuration,
  },

  computed: {
    ...mapState(['onLine']),
    ...mapState('match', ['match']),
  },
})
export default class PenaltiesDialog extends MatchMixin {
  @Prop() readonly dialog!: { open: boolean }

  /**
   * Add penalty
   */
  addPenalty(team: 'h' | 'v', duration: number, text?: string): void {
    if (!this.match) {
      return
    }

    if (this.match.gcState === 'STARTED') {
      window.flash('Match must be paused', 'warning')
      return
    }

    const gcTime = Math.floor(
      timeNumericValue(this.match, this.$store.state.match.realtime.timestamp)
    )

    // console.log('New penality')

    const penalty = {
      duration, // Duration in seconds
      gcPeriod: currentPeriodNumber(this.match),
      gcTime, // Current game clock time (just floored)
      cancellable: true,
    } as Penalty

    if (text) {
      // penalty.text = text
    }
    // console.log('Adding penalty', penalty)

    const updateObj: { hPenalties?: Penalty[]; vPenalties?: Penalty[]; gcLastValue: number } = {
      // Update gc time with floored to current time second
      gcLastValue: gcTime,
    }
    const key = `${team}Penalties` as 'hPenalties' | 'vPenalties'
    updateObj[key] = [
      // Existing penalties array (or empty array if not existing)
      ...(this.match[key] || []),
      // Append new penalty
      penalty,
    ]

    // console.log('Adding penalty to team penalties', updateObj)

    // Get match
    db.collection('matches')
      .doc(this.match.id)
      // Add new one
      .update(updateObj)
      .then(() => {
        window.flash('Penalty added!')
      })
  }

  /**
   * Cancel penalty
   */
  cancelPenalty(team: 'h' | 'v', penalty: Penalty): void {
    // console.log('Cancel penalty', team, penalty)
    if (!this.match) {
      return
    }

    const key = `${team}Penalties` as 'hPenalties' | 'vPenalties'
    const penalties = this.match[key]
    if (!penalties) {
      // console.error('No penalties found in match', key, this.match)
      return
    }
    const foundIndex = penalties.findIndex(
      (p) =>
        // Find penalty that
        // - Must have same period number
        p.gcPeriod === penalty.gcPeriod &&
        // - Must have same time
        p.gcTime === penalty.gcTime &&
        // - Must either dont have player jersey number, of if have, then must be the same
        (!('playerJerseyNumber' in penalty) ||
          penalty.playerJerseyNumber === p.playerJerseyNumber) &&
        // May not be a cancelled penalty
        (!('cancelled' in p) || !p.cancelled)
    )

    if (foundIndex === -1) {
      window.flash('Error cancelling penalty...', 'error')
      return
    }

    // Update item in array of penalties
    penalties[foundIndex].cancelled = true

    const updateObj: { hPenalties?: Penalty[]; vPenalties?: Penalty[] } = {}

    updateObj[key] = penalties

    // console.log('Updated penalties', updateObj)

    // Get match
    db.collection('matches')
      .doc(this.match.id)
      // Add new one
      .update(updateObj)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .then((_res) => {
        window.flash('Penalty cancelled!')
        // console.log('Cancelled penalty', _res)
      })
  }
}
